import axios from "axios"
import { API_BASE_URL } from "../config"
import { MedicalRecordResponse } from "./medical_record"

export type FrontMedicalRecordResponse = {
  facility?: {
    facility_id?: string
    name?: string
    address?: string
    phone?: string
    building_type?: number
    detection?: number
    alert?: number
    catv_name?: string
  }
  medical_record?: MedicalRecordResponse
  history_graph?: Record<string, unknown>
  history?: any[]
}

export const getFrontMedicalRecord = async (
  id: string,
  facility_id: string
): Promise<FrontMedicalRecordResponse | undefined> => {
  for (let i = 0; i < 3; i++) {
    try {
      const response = await axios.post(`${API_BASE_URL}/front/medical_record`, {
        session_code: localStorage.getItem("session_code"),
        id: id,
        facility_id: facility_id
      })

      if (response.data.session_code) {
        localStorage.setItem("session_code", response.data.session_code)
      }

      return response.data
    } catch (error: any) {
      if (error.code && error.code == "ERR_NETWORK" && i != 2) {
        continue
      }
      throw error
    }
  }
}
